import React from "react";
import BhkFloorTabs from "./BhkFloorTabs";

export default function BuyDetails({
  propData,
  bhkdata,
  activeBhk,
  activeFloorDetail,
  onBhkChange,
  onFloorChange,
  children, // <- drop the Floor Plan block in here so it sits under the grid
}) {
  return (
    <div className="PropertyDetails property-details-block">
      <div className="row">
        <div className="col-12">
          <div className="property-detail">
            {/* Title + BHK tabs on the same line, floor tabs underneath */}
            <div className="details-head d-flex justify-content-between align-items-center flex-wrap mb-3 gap-2 gap-md-0">
              <h3 className="mb-0">Property Details</h3>
              <BhkFloorTabs
                bhkdata={bhkdata}
                activeBhk={activeBhk}
                activeFloorDetail={activeFloorDetail}
                onBhkChange={onBhkChange}
                onFloorChange={onFloorChange}
                showFloors={false}
              />
            </div>

            <BhkFloorTabs
              bhkdata={bhkdata}
              activeBhk={activeBhk}
              activeFloorDetail={activeFloorDetail}
              onBhkChange={onBhkChange}
              onFloorChange={onFloorChange}
              className="details-floor-tabs"
              showBhk={false}
            />

            {/* key = remount on change, which replays the flash animation */}
            <ul
              className="property-Details-grid detail-flash"
              key={`${activeBhk}-${activeFloorDetail?.id ?? "none"}`}
            >
              <li>
                Property Name{" "}
                <span>{propData?.propertyDTO?.propertyName || "-"}</span>
              </li>

              <li>
                Property Type <span>{propData?.propertyDTO?.type || "-"}</span>
              </li>

              {activeFloorDetail?.carpetArea ||
              propData?.propertyDTO?.carpetArea ? (
                <li>
                  Carpet Area{" "}
                  <span>
                    {activeFloorDetail?.carpetArea
                      ? activeFloorDetail.carpetArea
                      : propData?.propertyDTO?.carpetArea}{" "}
                    sq ft
                  </span>
                </li>
              ) : null}

              {activeFloorDetail?.balconies ? (
                <li>
                  Balconies <span>{activeFloorDetail.balconies}</span>
                </li>
              ) : null}

              <li>
                Super Built-up Area{" "}
                <span>
                  {activeFloorDetail?.buildUpArea
                    ? activeFloorDetail.buildUpArea
                    : propData?.propertyDTO?.buildUpArea || "-"}{" "}
                  Sq Ft
                </span>
              </li>

              {propData?.propertyDTO?.petsAllowed !== null ? (
                <li>
                  Pets Allowed{" "}
                  <span>
                    {propData?.propertyDTO?.petsAllowed === true
                      ? "Yes"
                      : propData?.propertyDTO?.petsAllowed === false
                        ? "No"
                        : "-"}
                  </span>
                </li>
              ) : null}

              {propData?.propertyDTO?.PropertyAge ? (
                <li>
                  Age of Property{" "}
                  <span>{propData.propertyDTO.PropertyAge}</span>
                </li>
              ) : null}

              {activeFloorDetail?.powerBackUp ? (
                <li>
                  Power Backup <span>{activeFloorDetail.powerBackUp}</span>
                </li>
              ) : null}

              {activeFloorDetail?.floor !== null &&
              activeFloorDetail?.floor !== undefined ? (
                <li>
                  Floor{" "}
                  <span>
                    {activeFloorDetail.floor === 0
                      ? "Ground Floor"
                      : activeFloorDetail.floor}
                  </span>
                </li>
              ) : propData?.propertyDTO?.floors ? (
                <li>
                  Floor <span>{propData.propertyDTO.floors}</span>
                </li>
              ) : null}

              <li>
                Facing{" "}
                <span>
                  {activeFloorDetail?.facing
                    ? activeFloorDetail.facing
                    : propData?.propertyDTO?.facing || "-"}
                </span>
              </li>

              {propData?.propertyDTO?.fullParkingDetails ? (
                <li>
                  Parking <span>{propData.propertyDTO.fullParkingDetails}</span>
                </li>
              ) : null}

              {activeFloorDetail?.length ? (
                <li>
                  Property Length<span>{activeFloorDetail.length} ft</span>
                </li>
              ) : null}

              {activeFloorDetail?.width ? (
                <li>
                  Property Breadth<span>{activeFloorDetail.width} ft</span>
                </li>
              ) : null}

              {activeFloorDetail?.noOfOpenSides ? (
                <li>
                  No. of Open Sides
                  <span>{activeFloorDetail.noOfOpenSides}</span>
                </li>
              ) : null}

              {activeFloorDetail?.furnishingStatus ? (
                <li>
                  Furnishing Status
                  <span>{activeFloorDetail.furnishingStatus}</span>
                </li>
              ) : null}

              {activeFloorDetail?.noOfRooms ? (
                <li>
                  Bedrooms<span>{activeFloorDetail.noOfRooms}</span>
                </li>
              ) : null}

              {activeFloorDetail?.noOfBathRooms ? (
                <li>
                  Bathrooms<span>{activeFloorDetail.noOfBathRooms}</span>
                </li>
              ) : null}
            </ul>

            {/* Floor plan / map renders right here, under the same tabs */}
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}